import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
document.title = "DesbloqueARTE — Guía del Método de los 8 Minutos";

// Meta Pixel Code
// @ts-expect-error Meta Pixel global
!function (f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
// @ts-expect-error Meta Pixel global
fbq('init', '2102714733702268');
// @ts-expect-error Meta Pixel global
fbq('track', 'PageView');
// End Meta Pixel Code

const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-198" data-mp="2tws7nvinfe2h" />);
}